export type AddressModel = {
  cache_key?: number,
  id: number,
  address_line_1: string,
  address_line_2?: string,
  address_postcode: string,
  address_region?: string,
  address_state: string,
  geo_country_id?: number,
  is_default?: boolean,
  owner_id: number,
  owner_type: string,
  title: string,
}

export type AddressRequestOptions = {}

const state = {
  id: null,
  address_line_1: '',
  address_line_2: '',
  address_postcode: '',
  address_region: '',
  address_state: '',
  geo_country_id: undefined,
  is_default: false,
  owner_id: undefined,
  owner_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'address_line_1' },
  { key: 'address_postcode' },
  { key: 'address_region' },
  { key: 'address_state' },
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'title' },
]

export default state
